import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * Chevron Left icon for backward navigation
 */
export const ChevronLeftIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <polyline points="15 18 9 12 15 6"></polyline>
    </Icon>
  );
};

export default ChevronLeftIcon;
